import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import {
  CdkDragDrop,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  moveItemInArray,
  transferArrayItem,
} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-product-composition-list',
  templateUrl: './product-composition-list.component.html',
  styleUrls: ['./product-composition-list.component.css']
})
export class ProductCompositionListComponent implements OnInit {

  productCompositioncList: any = []
  page: number = 0;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [3, 6, 9, 12];
  singleproductCompositionData: any = []
  first: number = 0;
  isLoading: any = false

  // Add/Edit Properties
  isAdd: boolean = false
  isEdit: boolean = false
  isRefresh: boolean = false
  editData: any = null

  amount: any = 0
  cProductList: any[] = [];
  cProductListFilter: any[] = [];
  productList: any = []
  productName: string = ""
  batchPrice: any = ""
  batchQuantity: any = 1
  isDefault: any = ""
  done: any = [];
  searchBoxTxt: string = '';
  listSearchQuery: string = '';
  cid: any;

  uomData: any = [];
  uomDropdownList: any = [];
  uomSelectedList: any = [];
  uomDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'uomMasterId',
    textField: 'uomName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  deleteId: any = null

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  }

  constructor(private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid');
    let href: any = window.location.href;
    let messages = href.split('/')
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1])
    this.actionControls = action

    this.getAllProductComposition();
    this.getAllUomMaster();
    this.getAllCProduct();
    this.getAllcProductMaster()
  }

  // --- Listing Methods ---
  getAllProductComposition() {
    this.isLoading = true;
    if (this.listSearchQuery) {
      this.generic_service.getProductCompositionByWildSearch(this.listSearchQuery, this.page, this.tableSize).subscribe(
        (response: any) => {
          this.productCompositioncList = response.response.productCompositionList || [];
          this.count = response.response.totalRecords || 0;
          this.checkCompositionRefresh();
          this.isLoading = false;
        },
        (err: any) => {
          this.isLoading = false;
          console.log(err);
        }
      );
    } else {
      this.generic_service.getAllProductComposition(this.page, this.tableSize).subscribe(
        (response: any) => {
          this.productCompositioncList = response.response.productCompositionList || [];
          this.count = response.response.totalRecords || 0;
          this.checkCompositionRefresh();
          this.isLoading = false;
        },
        (err: any) => {
          this.isLoading = false;
          console.log(err);
        }
      );
    }
  }

  checkCompositionRefresh() {
    if (!this.productCompositioncList || this.productCompositioncList.length === 0) {
      return;
    }
    if (!this.productList || this.productList.length === 0) {
      this.generic_service.getAllcProductMaster().subscribe(
        (res: any) => {
          this.productList = res.response || [];
          this.applyRefreshCheck();
        },
        (err: any) => {
          console.log(err);
        }
      );
    } else {
      this.applyRefreshCheck();
    }
  }

  applyRefreshCheck() {
    if (!this.productCompositioncList || !this.productList || this.productList.length === 0) {
      return;
    }
    this.productCompositioncList.forEach((product: any) => {
      let isRefresh = false;
      if (product.productCompositionIngList && product.productCompositionIngList.length > 0) {
        for (const item of product.productCompositionIngList) {
          const matched = this.productList.find(
            (p: any) => p.name?.trim() === item.name?.trim()
          );
          if (
            matched &&
            matched.price !== undefined &&
            matched.price !== null &&
            item.price !== undefined &&
            item.price !== null &&
            Math.abs(Number(matched.price) - Number(item.price)) > 0.001
          ) {
            isRefresh = true;
            break;
          }
        }
      }
      product.isRefresh = isRefresh;
    });
  }


  onRowClick(event: Event, id: any) {
    const target = event.target as HTMLElement;
    if (target.closest('.action-buttons')) {
      return;
    }
    this.getProductCompositionById(id);
    document.getElementById("openViewModalBtn")?.click();
  }

  getProductCompositionById(id: any) {
    this.generic_service.getProductCompositionById(id).subscribe(
      (res: any) => {
        let totalAmount: any = 0
        for (var i = 0; i < res.response.productCompositionIngList.length; i++) {
          totalAmount += res.response.productCompositionIngList[i].qty * res.response.productCompositionIngList[i].price
        }
        res.response.totalAmount = totalAmount
        this.singleproductCompositionData = [res.response]
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  onTableDataChange(event: any) {
    this.page = event.page;
    this.first = event.first;
    this.tableSize = event.rows;
    this.getAllProductComposition();
  }

  onSearchChange() {
    this.page = 0;
    this.first = 0;
    this.getAllProductComposition();
  }

  // --- Add/Edit Methods ---
  add() {
    this.isAdd = true;
    this.isEdit = false;
    this.resetForm();
  }

  editComposition(id: any) {
    this.generic_service.getProductCompositionById(id).subscribe(
      (res: any) => {
        this.editData = res.response;
        this.isEdit = true;
        this.isAdd = true;
        this.isRefresh = false;
        this.populateEditData();
      },
      (err: any) => {
        this.toastr.error("Failed to fetch composition details");
      }
    )
  }

  refreshComposition(id: any) {
    this.generic_service.getProductCompositionById(id).subscribe(
      (res: any) => {
        this.editData = res.response;
        this.isEdit = true;
        this.isAdd = false;
        this.isRefresh = true;
        this.populateRefreshData();
      },
      (err: any) => {
        this.toastr.error("Failed to fetch composition details");
      }
    )
  }

  getAllcProductMaster() {
    this.generic_service.getAllcProductMaster().subscribe(
      (res: any) => {
        console.log(res.response)
        this.productList = res.response
        this.applyRefreshCheck();
      },
      (err: any) => {
        console.log(err)
      }
    )
  }


  getCproductMasterById(cProductId: any) {
    this.generic_service.getCproductMasterById(cProductId).subscribe(
      (res: any) => {
        console.log(res)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  populateRefreshData() {
    this.productName = this.editData.productName;
    this.batchPrice = this.editData.batchPrice;
    this.batchQuantity = this.editData.batchQuantity;
    // this.amount = this.editData.totalAmount || 0;

    let ingredients = JSON.parse(JSON.stringify(this.editData.productCompositionIngList));
    ingredients.forEach((item: any) => {
      const matchedProduct = this.cProductList.find((p: any) => p.name === item.name);
      item.supportedUOM = matchedProduct ? matchedProduct.supportedUOM : [];
      if (matchedProduct && !item.code) {
        item.code = matchedProduct.code;
      }
      console.log(matchedProduct)
      this.productList.find((p: any) => {
        if (p.name === item.name) {
          item.newPrice = p.price;
          item.oldPrice = item.price;
          item.price = item.newPrice;
        }
      });
      this.amount += item.qty * item.newPrice;

    });




    console.log(ingredients)
    this.done = ingredients;

    this.uomSelectedList = [];
    if (this.editData.supportedUOMObjList) {
      for (let i = 0; i < this.editData.supportedUOMObjList.length; i++) {
        this.uomSelectedList.push({
          "uomMasterId": this.editData.supportedUOMObjList[i].uomId,
          "uomName": this.editData.supportedUOMObjList[i].uomName
        });
        if (this.editData.supportedUOMObjList[i].isDefault) {
          this.isDefault = this.editData.supportedUOMObjList[i].uomId;
        }
      }
    }
  }

  populateEditData() {
    this.productName = this.editData.productName;
    this.batchPrice = this.editData.batchPrice;
    this.batchQuantity = this.editData.batchQuantity;
    this.amount = this.editData.totalAmount || 0;

    let ingredients = JSON.parse(JSON.stringify(this.editData.productCompositionIngList));
    ingredients.forEach((item: any) => {
      const matchedProduct = this.cProductList.find((p: any) => p.name === item.name);
      item.supportedUOM = matchedProduct ? matchedProduct.supportedUOM : [];
      if (matchedProduct && !item.code) {
        item.code = matchedProduct.code;
      }
    });
    this.done = ingredients;

    this.uomSelectedList = [];
    if (this.editData.supportedUOMObjList) {
      for (let i = 0; i < this.editData.supportedUOMObjList.length; i++) {
        this.uomSelectedList.push({
          "uomMasterId": this.editData.supportedUOMObjList[i].uomId,
          "uomName": this.editData.supportedUOMObjList[i].uomName
        });
        if (this.editData.supportedUOMObjList[i].isDefault) {
          this.isDefault = this.editData.supportedUOMObjList[i].uomId;
        }
      }
    }
    this.amountChanged();
    this.filterProducts();
  }

  closeAdd() {
    this.isAdd = false;
    this.isEdit = false;
    this.isRefresh = false;
    this.editData = null;
    this.resetForm();
    this.getAllProductComposition();
  }

  closeRefresh() {
    this.isAdd = false;
    this.isEdit = false;
    this.isRefresh = false;
    this.editData = null;
    this.resetForm();
    this.getAllProductComposition();
  }

  resetForm() {
    this.productName = "";
    this.batchQuantity = "1";
    this.batchPrice = "";
    this.isDefault = "";
    this.done = [];
    this.amount = 0;
    this.uomSelectedList = [];
    this.filterProducts();
  }

  // --- Core Composition Logic ---
  getAllUomMaster() {
    this.generic_service.getAllUomMaster().subscribe(
      (res: any) => {
        this.uomDropdownList = res.response
        this.uomData = res.response
      }
    )
  }

  getAllCProduct() {
    this.generic_service.getAllcProductMaster().subscribe(
      (response: any) => {
        this.cProductList = response.response.map((item: any) => {
          let body = {
            "name": String(item.name),
            "code": item.code,
            "qty": 1,
            "uom": "",
            "price": 0,
            "supportedUOM": item.supportedUOM
          }
          if (item.supportedUOM) {
            let defaultUom = item.supportedUOM.find((u: any) => u.isDefault);
            if (defaultUom) {
              body.uom = defaultUom.uomName;
              body.price = defaultUom.price;
            }
          }
          return body;
        });

        if (this.isEdit && this.done.length > 0) {
          this.done.forEach((item: any) => {
            if (!item.supportedUOM || item.supportedUOM.length === 0) {
              const matchedProduct = this.cProductList.find((p: any) => p.name === item.name);
              item.supportedUOM = matchedProduct ? matchedProduct.supportedUOM : [];
            }
          });
        }
        this.filterProducts();
      }
    )
  }

  filterProducts() {
    const availableProducts = this.cProductList.filter(
      (product: any) => !this.done.some((doneItem: any) => doneItem.code === product.code)
    );

    if (this.searchBoxTxt) {
      const lowerTxt = this.searchBoxTxt.toLowerCase();
      this.cProductListFilter = availableProducts.filter((item: any) =>
        item.code.toLowerCase().includes(lowerTxt)
      );
    } else {
      this.cProductListFilter = availableProducts;
    }
    console.log(this.cProductListFilter)
  }

  drop(event: CdkDragDrop<any[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.filterProducts();
    }
    this.amountChanged();
  }

  addItem(item: any, index: number) {
    this.done.push(item);
    item.qty = 1;
    this.filterProducts();
    this.amountChanged();
  }

  removeItem(item: any, index: number) {
    this.done.splice(index, 1);
    this.filterProducts();
    this.amountChanged();
  }

  amountChanged() {
    this.amount = 0;
    this.done.forEach((item: any) => {
      this.amount += (Number(item.price) || 0) * (Number(item.qty) || 0);
    });
    this.batchPrice = this.amount

  }

  uomChange(event: any, index: any) {
    const selectedUomName = event.target.value;
    const item = this.done[index];
    const uom = item.supportedUOM.find((u: any) => u.uomName === selectedUomName);
    if (uom) {
      item.price = uom.price;
    }
    this.amountChanged();
  }

  save() {
    let supportedUOMObjList: any = [];
    this.uomSelectedList.forEach((selected: any) => {
      const master = this.uomDropdownList.find((u: any) => u.uomMasterId === selected.uomMasterId);
      if (master) {
        supportedUOMObjList.push({
          "uomId": master.uomMasterId,
          "uomName": master.uomName,
          "cid": master.cid,
          "isDefault": master.uomMasterId == this.isDefault
        });
      }
    });

    const ingredients = this.done.map((item: any) => {
      const { supportedUOM, ...rest } = item;
      return rest;
    });

    this.batchPrice = this.amount

    let body = {
      "version": this.isEdit ? this.editData.version : 0,
      "isActive": true,
      "description": "",
      "productCompositionId": this.isEdit ? this.editData.productCompositionId : 0,
      "productName": String(this.productName),
      "batchPrice": Number(this.batchPrice),
      "batchQuantity": Number(this.batchQuantity),
      "totalAmount": Number(this.amount),
      "supportedUOMObjList": supportedUOMObjList,
      "productCompositionIngList": ingredients,
      "cid": Number(this.cid)
    };

    console.log(body)

    const request = this.isEdit
      ? this.generic_service.updateProdcutComposition(body)
      : this.generic_service.addProductComposition(body);

    request.subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.getAllProductComposition();
        this.closeAdd();
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
      }
    );
  }

  // --- Delete Methods ---
  deleteProduct(deleteId: any, id: any, name: string) {
    this.deleteId = deleteId
    this.productName = name;
  }

  confirmDelete() {
    this.generic_service.deleteProductComposition(this.deleteId).subscribe(
      (res: any) => {
        this.toastr.success("Successfully Deleted");
        this.getAllProductComposition();
        this.cancelModel();
      },
      (err: any) => {
        this.toastr.error(err.errors[0].description);
      }
    );
  }

  cancelModel() {
    const closeBtns = document.querySelectorAll('[data-dismiss="modal"]');
    closeBtns.forEach((btn: any) => btn.click());
  }

  enforcePositiveNumber(event: any) {
    if (event.target.value < 0) {
      event.target.value = 0;
    }
  }

}

